/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import * as yup from 'yup';
import { sanitizeValidation } from '../../common/utils/sanitize';
/**
 * Sign up form validations are defined here
 */
const forbiddenUsernames = ['user', 'users', 'admin', 'admins', 'root', 'preferred'];
//
const signUpFormValidation = yup.object().shape({
  username: yup
    .string()
    .trim()
    .required('Username is required')
    .matches(/^[a-zA-Z0-9_.@]*$/, 'Can contain only Alphabets, numbers . and @')
    .max(25, 'Username should not have more than 25 characters')
    .test('is-not-forbidden', (value) => {
      if (value && forbiddenUsernames.includes(value.toLowerCase())) {
        return new yup.ValidationError(`Username cannot be '${value}'`, null, 'username');
      }
      return true;
    })
    .test((value, e) => sanitizeValidation(value, e.path)),
  firstName: yup
    .string()
    .trim()
    .required('First Name is required')
    .test((value, e) => sanitizeValidation(value, e.path)),
  lastName: yup
    .string()
    .trim()
    .required('Last Name is required')
    .test((value, e) => sanitizeValidation(value, e.path)),
  newPassword: yup
    .string()
    .required('Password is required')
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character'
    ),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref('newPassword'), null], 'Passwords must match')
    .required('Password confirmation is required'),
});
//
export default signUpFormValidation;
